const threeColumnTeams = {
  displayField: 'header',
  name: 'Three Column Teams',
  description: '',
  fields: [
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'eyebrow',
      name: 'Eyebrow',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyText',
      name: 'Body Text',
      type: 'Text',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'people',
      name: 'People',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: { type: 'Link', validations: [], linkType: 'Entry' }
    },
    {
      id: 'ctaText',
      name: 'Button Text',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'ctaUrl',
      name: 'Button Url',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'threeColumnTeams',
    version: 9,
    updatedAt: '2023-08-03T14:41:39.170Z'
  }
};
export default threeColumnTeams;